import React from "react";
import {
  welcomeBlock,
  styledForm,
  title,
  title1,
  styledFormCheckout,
  checkoutTitle,
} from "./LoginForm.module.scss";
import Form from "react-bootstrap/Form";
import { Constants } from "../../../@types/Constants";
import ErrorMessageAlert from "../ErrorMessageAlert/ErrorMessageAlert";

export const WelcomeBlock: React.FC<any> = (props) => {
  return (
    <div
      className={`${welcomeBlock} ${
        props.displayWelcome ? "d-none" : "d-block"
      }`}
    >
      {props.children}
    </div>
  );
};

export const Title: React.FC<any> = (props) => {
  return (
    <div
      className={
        props.isFrom === "checkout" || props.isFrom === "edit-reservation"
          ? checkoutTitle
          : title
      }
    >
      {props.children}
    </div>
  );
};

export const Title1: React.FC<any> = (props) => {
  return <h1 className={title1}>{props.children}</h1>;
};

export const StyledForm: React.FC<any> = (props) => {
  return (
    <Form
      className={
        props.isFrom === "checkout" || props.isFrom === "edit-reservation"
          ? `${styledFormCheckout}  ${props.class} form-wrapper`
          : `${styledForm} ${props.class} form-wrapper`
      }
      onSubmit={props.onSubmit}
    >
      {props.children}
    </Form>
  );
};

export const TrackErrorMessage: React.FC<{
  message: string;
  field: string;
}> = (props) => {
  const trackMessage =
    props.message && typeof props.message !== undefined
      ? `${props.message} - ${props.field}`
      : "";
  return (
    <ErrorMessageAlert
      errorType={Constants.ERRORSTYPE.TRAVELPASS}
      errorSubType={Constants.ERRORSSUBTYPE.TRAVELPASS.SIGNIN}
      message={trackMessage}
    >
      {props.message}
    </ErrorMessageAlert>
  );
};
